var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../baseService';
export class LivequeuConsultationService extends BaseService {
    constructor(props) {
        super(props);
    }
    createConsultation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi('interservice/consultations', 'post', params);
            return data;
        });
    }
    setTelehealthAppointment(consultationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`interservice/consultations/${consultationId}/set-telehealth-appointment`, 'put', params);
            return data;
        });
    }
    setIdentifiers(consultationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`interservice/consultations/${consultationId}/identifiers`, 'put', params);
            return data;
        });
    }
    getConsultationById(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}`, 'get');
            return data;
        });
    }
    updateConsultation(consultationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}`, 'put', params);
            return data;
        });
    }
    searchConsultations(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi('consultations/search', 'post', params);
            return data;
        });
    }
    // async assignConsultation(
    //   consultationId: string,
    //   params: CRUD['AssignConsultation'],
    // ): Promise<Consultation> {
    //   const { data }: AxiosResponse = await this.api.fetchOpenApi(
    //     `consultations/${consultationId}/assign`,
    //     'post',
    //     params,
    //   )
    //   return data
    // }
    completeConsultation(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/complete`, 'post', {}, { skipAlert: true });
            return data;
        });
    }
    cancelConsultation(consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/cancel`, 'post');
            return data;
        });
    }
    // async holdNextConsultation(): Promise<Consultation> {
    //   const { data }: AxiosResponse = await this.api.fetchOpenApi(
    //     `consultations/hold-next`,
    //     'post',
    //     {},
    //   )
    //   return data
    // }
    // async startConsultation(consultationId: string): Promise<Consultation> {
    //   const { data }: AxiosResponse = await this.api.fetchOpenApi(
    //     `consultations/${consultationId}/start`,
    //     'get',
    //   )
    //   return data
    // }
    uploadAttachments(consultationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/uploads`, 'post', payload);
            return data;
        });
    }
    confirmAttachmentsUpload(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/uploads/confirm`, 'post', [uploadRecordId]);
            return data;
        });
    }
    cancelAttachmentUpload(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/uploads/${uploadRecordId}/cancel`, 'post', {});
            return;
        });
    }
    getAttachmentDownloadUrl(uploadRecordId, consultationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/uploads/${uploadRecordId}/download-url`, 'get');
            return data;
        });
    }
    createAttachmentRequirement(consultationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/requirements`, 'post', params);
            return data;
        });
    }
    verifyAttachmentRequirement(consultationId, attachmentRequirementId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/${consultationId}/attachments/requirements/${attachmentRequirementId}/verify`, 'post', params);
            return data;
        });
    }
    getConsultationsServicesList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`consultations/services`, 'get', null, { query: params });
            return data;
        });
    }
}
